import { render, staticRenderFns } from "./manage-game-services.vue?vue&type=template&id=1956e610&scoped=true&"
import script from "./manage-game-services.vue?vue&type=script&lang=js&"
export * from "./manage-game-services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956e610",
  null
  
)

export default component.exports